import { Box } from "@mui/material"
import TableDiv from '../components/Products/TableDiv'
import React from "react"

const schema = {
  TABLE: { name: 'animal_categorys', label: '产品', display: false, xlsx: false },
  category: { name: 'animal_category', label: '产品', display: false, xlsx: false, default: '动物-分类' },
  mainImage: { label: '例图', addable: true, editable: true, xlsx: true },
  // images: { label: '参考图', addable: false, editable: true, xlsx: true },
  main_category: { label: '主分类', addable: true, editable: true, xlsx: true },
  sub_category: { label: '子分类', addable: true, editable: true, xlsx: true },
  animal_tags: { label: '标签', addable: false, editable: true, xlsx: false },
  introduction: { label: '介绍', addable: true, editable: true, xlsx: true },
  createdAt: { label: '创建时间', addable: false, editable: false, xlsx: false },
}

function Animals_category(props: any) {
  return (
    <Box>
      <TableDiv
        schema={schema}
        newAlert={props.newAlert}
        reloadArg={props.reloadArg}
      >
      </TableDiv>
    </Box>
  )
}

export default Animals_category